import React, { useEffect, useState } from "react";
import { LayoutTemplate } from "lucide-react";
import { createTaskTemplateApi } from "../api/taskTemplateApi";
import { templateStepCount } from "../utils/taskTemplates";

const TaskTemplatePicker = ({ apiUrl, getToken, onApply, disabled = false }) => {
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        let cancelled = false;
        const api = createTaskTemplateApi({ apiUrl, getToken });
        api.fetchTemplates()
            .then((rows) => {
                if (!cancelled) setTemplates(rows);
            })
            .catch(() => {
                if (!cancelled) setTemplates([]);
            });
        return () => {
            cancelled = true;
        };
        // Token is recreated each render; fetch once per mount/apiUrl.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiUrl]);

    if (!templates.length) return null;

    return (
        <div className="task-template-picker">
            <label className="oms-form-label">
                <LayoutTemplate size={14} />
                Use a template
            </label>
            <select
                disabled={disabled}
                defaultValue=""
                onChange={(e) => {
                    const id = e.target.value;
                    const tpl = templates.find((row) => String(row.id) === id);
                    if (tpl) onApply?.(tpl);
                    e.target.value = "";
                }}
            >
                <option value="">Choose template…</option>
                {templates.map((row) => (
                    <option key={row.id} value={row.id}>
                        {row.name}
                        {templateStepCount(row) ? ` · ${templateStepCount(row)} steps` : ""}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default TaskTemplatePicker;
